<template>

<div class="bootstrap modal-content">
      <div class="modal-header">
        <h5 class="modal-title">{{boardMst.boardNm}} 팝업 <span class="l-bar fs12">제목을 클릭하시면 내용보기 화면으로 이동합니다.</span></h5>
        <button type="button" class="close" @click="$emit('dismiss')">X</button>
      </div>
      <div class="modal-body" style="padding:20px">

        <el-table
            :data="items"
            :row-class-name="getRowClass"
            stripe
            style="width: 100%"
            >

            <el-table-column label="번호" type="index" :index="indexMethod"  width="80">
            </el-table-column>
            <el-table-column v-show="boardMst.categoryYn === 'Y'" label="분류" width="160">
                <template slot-scope="prop">
                    <span :class="pickClass('categoryList',prop.row.category)">{{ prop.row.category }}</span>
                </template>
            </el-table-column>
            
            <el-table-column label="제목"  >
                <template slot-scope="prop">
                <a @click.prevent="goRead(prop.row)" href="#">{{prop.row.articleTitle}}</a> 
                <i v-if="prop.row.secretYn === 'Y'" class="ml-2 el-icon-lock text-danger font-weight-bold fs16"></i>
                </template>
            </el-table-column>


            <el-table-column label="작성자" prop="writerNm" width="180">
            </el-table-column>
            <el-table-column label="작성일"  width="180">
                <template slot-scope="prop">
                    {{ prop.row.createDt | moment('YYYY.MM.DD HH:mm') }}
                </template>
            </el-table-column>
            <el-table-column v-if="boardMst.stateYn == 'Y'" label="상태" width="140">
                <template slot-scope="prop">
                    <span :class="pickClass('stateList',prop.row.state)">{{ prop.row.state }}</span>
                </template>
            </el-table-column>

        </el-table>
        <el-row type="flex" justify="center" class="mt-4">
            <p-pagination class="text-center"
                        v-on:input="searchAction"
                        v-model="pagination.currentPage"
                        :per-page="searchParams.rows"
                        :total="pagination.totalCount">
            </p-pagination>
        </el-row>

    </div>
      <div class="modal-footer">
        <el-checkbox v-model="doNotShow1Day" label="오늘 하루 이 창을 열지 않음" border></el-checkbox>
            <el-button class="ml-1" @click="close">닫 기</el-button>

<!-- 
        <button type="button" class="btn btn-secondary" @click="hideAll" data-bs-dismiss="modal">Close</button>
        <button type="button" class="btn btn-primary" @click="other">Save changes</button> -->


      </div>
    </div>




</template>

<script>
import PPagination from 'src/components/UIComponents/Pagination.vue'
import BoardProxy from '@/proxies/BoardProxy'

export default {
    components: {
        PPagination
    },
    props: {
        boardMst: Object,
        boardNo: Number
    },
    created() {

        this.searchAction(1)

    },
    methods: {
        close() {
            this.$emit('close', this.doNotShow1Day )
        },
        goRead(row) {

            this.$router.push({
                    path : `/mng/board/view/${this.boardNo}/${row.articleNo}`, 
                    params: {
                        boardNo: this.boardNo,
                        articleNo: row.articleNo,
                    }
            })

        },
        getRowClass({row, rowIndex}) {

            if(row.deleteYn === 'Y') {
                return 'deleted'
            }

        },
        searchAction(page) {
            
            this.searchParams.page = page
            this.pagination.currentPage = page || 1;

            let query = '?'
            for(const key in this.searchParams) {
                if(this.searchParams[key]) {
                    query += `${key}=${encodeURIComponent(this.searchParams[key])}&`
                }
            }
            
            return new BoardProxy( this.searchParams )
            .getArticleList( this.boardNo )
            .then(res => {
                this.items = [...res.items]
                this.pagination.totalCount = res.totalCount
            })

              
        },
        indexMethod(index) {
            
            return this.pagination.totalCount - ((this.pagination.currentPage-1) * this.searchParams.rows) - index
        },
        pickClass( dest, value ) {

            return (this.boardMst[dest].find(item=>item.value === value) || {}).cls

        },
    },
    /*
    watch: {
        boardMst( boardMst ) {
            if(boardMst.boardNo && boardMst.boardNo !== this.oldBoardNo) {
               this.searchAction(1)
               this.oldBoardNo = this.boardNo
            }
        }
    },*/
    data() {

        return {
            searchParams: {
                page: 0,
                scroll: 0,
                rows: 10,                
            },
            items: [],
            pagination: {
                currentPage: 1,
                totalCount: 0
            },
            doNotShow1Day: false
        }
    }

}
</script>

<style>
tr.el-table__row.deleted {text-decoration: line-through;}
</style>